import { CrmInteractionOriginator } from "@enums/crmInteractionOriginator.enum";
import { CrmInteractionRating } from "@enums/crmInteractionRating.enum";
import { InteractionType } from "@enums/interactionType.enum";
import { Model } from "@interfaces/model.interface";

export interface CrmInteraction extends Model {
	clientId?: number;
	crmContactId?: number;
	crmEventId?: number;
	crmLeadId?: number;
	followUpDate?: Date;
	instigatorId: number;
	interactionDate: Date;
	interactionType: InteractionType;
	isSensitive: boolean;
	originator: CrmInteractionOriginator;
	outcome: string;
	rating?: CrmInteractionRating;
	summary: string;
}

export class CrmInteraction implements CrmInteraction {

	constructor(data?: Partial<CrmInteraction>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
